import {Stack} from '@customink/pigment-react';
import React, {useState} from 'react';
import ProductDetailsRow from 'product_details_page/ProductDetailsRow';
import ProductDescription from 'product_details_page/ProductDetailsSection/ProductDescription';
import ProductDetails from 'product_details_page/ProductDetailsSection/ProductDetails';
import {trackProductDescriptionPageAccordionClick} from 'utils/analytics';

export default function ProductDescriptionAndFeatures() {
  const [detailsAccordionExpanded, setDetailsAccordionExpanded] =
    useState(false);

  return (
    <ProductDetailsRow
      title="Description and Features"
      accordionSummary="Description and Features"
      accordionExpanded={detailsAccordionExpanded}
      accordionWrapperSx={{px: 0}}
      useAccordionAlways
      onAccordionClick={() => {
        setDetailsAccordionExpanded(!detailsAccordionExpanded);
        trackProductDescriptionPageAccordionClick(
          'description and features',
          detailsAccordionExpanded
        );
      }}>
      <Stack>
        <ProductDescription />
        <ProductDetails />
      </Stack>
    </ProductDetailsRow>
  );
}
